import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../Style/About.scss";

const About = () => {
  return (
    <div className="about_wrapper">
      <Container>
        <Row>
          <Col className="col-md-12">
            <div className="section_title">
              <h3>
                ABOUT<span className="span">3W</span> STUDIO
              </h3>
            </div>
          </Col>
          <Col className="col-md-12">
            <div className="about_area">
              <p className="about-par1">
                F5 Studio was founded in 2013 to help companies to achieve their
                business goals on the Web in the best way.Our web designers,
                UI/UX specialists, web developers and digital marketers work
                together to create beautiful, well-organized, and unique
                solutions.
              </p>
              .
              <br />
              <p className="about-par2">
                To bring your business to a new level our masters are not
                limited to standard methods. This approach in web design and
                development helps us find solutions, especially for your
                business. In nutshell, we create something you'll be proud of!
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;
